<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item,index in statusList" :label="`${item}(${regularizationMapping[index]})`" :name="item" lazy :key="item">
      </el-tab-pane>
      <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" :tableType="tableType" ref="InterForm" />

      <InterBtnBox :selectedRows="selectedRows" @overEmit="getDataSource" :tableType="tableType"
        @refeash="getDataSource" @queryHandler="queryHandler"/>

      <InterList :tableType="tableType" @refeash="getDataSource" :dataSource="dataSource" :clean='clean'
        @pageChange="pageChangeCall" @selectChange="selectChangeCall" ref="interlist" :total="query.total" :rowKye="'id'"></InterList>
    </el-tabs>
  </div>
</template>

<script>
import InterForm from '@/views/abnormal/regularization/components/InterForm'
import InterList from "@/views/abnormal/regularization/components/InterList";
import InterBtnBox from "@/views/abnormal/regularization/components/InterBtnBox";
import { regularizationCreateTask, regularizationDetail, regularizationPage } from "@/apis/abnormal";
import { statusList } from "@/views/abnormal/regularization/data.js";
export default {
  title: '次转正',
  name: "regularization",
  components: {
    InterForm,
    InterBtnBox, InterList
  },
  data() {
    return {
      statusList,
      activeName: '全部',
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      clean: false,
      selectedRows: [],
      dataSource: [{ pkgCode: '123', newPkgCode: '321', regularizationCode: "regularizationCode123", id: 'regularizationCode1' }],
      tableType: '全部',
      regularizationStatus: { all: 0, pending: null, processing: null, completed: null }
    }
  },
  // props: {
  //   forwarder: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  computed:{
    regularizationMapping:function(){
      let regularizationStatus = this.regularizationStatus
      return [regularizationStatus.all || 0,regularizationStatus.pending || 0,regularizationStatus.processing || 0,regularizationStatus.completed || 0]
    }
  },
  created() {
  },
  methods: {
    handleClick(e) {
      console.log(e)
      this.tableType = e.name
      this.queryHandler()
    },
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      };
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows;
    },
    getDataSource: function () {
      // 获取列表数据
      this.selectedRows = [];
      const params = {
        ...this.query,
        pageNum: this.query.current,
        state: { '全部': undefined, '待处理': 1, '处理中': 2, '已完成': 3 }[this.tableType]
      };
      this.clean = true;
      regularizationPage(params)
        .then((res) => {
          const {
            regularizationPage: { total = 0, records = [] },
          } = res.data;
          this.query.total = total;
          this.dataSource = records;
          this.regularizationStatus = res.data.regularizationStatus
          // const {}
        })
        .finally((_) => {
          this.clean = false;
        });
    }
  }
}
</script>

<style scoped>

</style>